module.exports = __webpack_public_path__ + "img/image1-2.85dfc480.jpeg";